import Badge from "@/components/ui/Badge";

// Only an admin ever sees a guide while the hold is on, so this says so --
// otherwise it looks like the guides are live when nobody else can read them.
export default function LockedNotice({ locked }: { locked: boolean }) {
  if (!locked) return null;

  return (
    <div className="border-line bg-surface-plain flex flex-wrap items-center gap-2 border-2 p-3">
      <Badge tone="warning">Held</Badge>
      <span className="text-body text-ink font-bold">
        Only you can see this.
      </span>
      <span className="text-caption text-ink-muted">
        Everyone else gets the holding page until the hold comes off in{" "}
        <a className="text-link font-bold underline" href="/admin/settings">
          program settings
        </a>
        .
      </span>
    </div>
  );
}
